import React, { useEffect } from 'react';
import WizardContext from '../Contexts';
import { PageProp, WizardContext as Context, AnyStep } from '..';
import { PageContext } from '../Contexts/PageContext';
const RenderComponent = ({
  name,
  children,
  register,
  active,
  badge,
  complete,
  loading,
  disabled,
  subTitle,
  title,
  update,
  activeAfterComplete,
  ...rest
}: PageProp & {
  register: (name: string, step: AnyStep) => void;
  update: (name: string, step: AnyStep) => void;
  onComplete: () => void;
  onLoad: () => void;
}) => {
  useEffect(() => {
    register(name, {
      name,
      active,
      badge,
      complete,
      loading,
      disabled,
      subTitle,
      title,
      activeAfterComplete,
      kind: 'step',
    });
  }, [
    active,
    activeAfterComplete,
    badge,
    complete,
    disabled,
    loading,
    name,
    register,
    subTitle,
    title,
  ]);

  useEffect(() => {
    update(name, {
      name,
      active,
      badge,
      complete,
      loading,
      disabled,
      subTitle,
      title,
      activeAfterComplete,
      kind: 'step',
    });
  }, [
    active,
    activeAfterComplete,
    badge,
    complete,
    disabled,
    loading,
    name,
    subTitle,
    title,
    update,
  ]);
  return (
    <PageContext.Provider value={rest}>
      {active ? children : null}
    </PageContext.Provider>
  );
};

const Page = (props: PageProp) => {
  return (
    <WizardContext.Consumer>
      {({ activePage, register, update, onComplete, onLoad }: Context) => {
        return (
          <RenderComponent
            {...props}
            update={update}
            onLoad={() => onLoad(props.name)}
            onComplete={() => onComplete(props.name)}
            active={activePage === props.name}
            register={register}
          />
        );
      }}
    </WizardContext.Consumer>
  );
};
export default Page;
